/* ============================================================
   KLOHEMA — Efectos: nav sticky, scroll-reveals, tilt 3D,
   parallax hero, menú móvil, buscador Shopify
   ============================================================ */
(function () {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const lerp = (a, b, t) => a + (b - a) * t;

  /* --- Nav sticky ----------------------------------------- */
  const nav = document.querySelector(".kl-nav");
  const onScroll = () => {
    if (nav) nav.classList.toggle("is-stuck", window.scrollY > 40);
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  /* --- Scroll reveals ------------------------------------- */
  const reveals = Array.from(document.querySelectorAll(".kl-reveal"));
  if (!reduce) document.body.classList.add("kl-anim");
  const revealVisible = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    for (let i = reveals.length - 1; i >= 0; i--) {
      const el = reveals[i];
      const r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) {
        el.classList.add("in");
        reveals.splice(i, 1);
      }
    }
  };
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    reveals.forEach((r) => io.observe(r));
  }
  revealVisible();
  window.addEventListener("scroll", revealVisible, { passive: true });
  window.addEventListener("resize", revealVisible, { passive: true });
  requestAnimationFrame(revealVisible);
  setTimeout(revealVisible, 250);

  /* --- Menú móvil ----------------------------------------- */
  (function () {
    const scrim = document.createElement("div");
    scrim.className = "kl-scrim";
    document.body.appendChild(scrim);
    const panel = document.createElement("nav");
    panel.className = "kl-nav__mobile";
    panel.setAttribute("aria-label", "Menú");
    const close = document.createElement("button");
    close.className = "kl-close"; close.setAttribute("aria-label", "Cerrar"); close.innerHTML = "&times;";
    panel.appendChild(close);
    const src = document.querySelector(".kl-nav__links");
    if (src) src.querySelectorAll("a").forEach((a) => panel.appendChild(a.cloneNode(true)));
    document.body.appendChild(panel);
    const openM = () => { panel.classList.add("open"); scrim.classList.add("show"); document.body.classList.add("menu-open"); };
    const closeM = () => { panel.classList.remove("open"); scrim.classList.remove("show"); document.body.classList.remove("menu-open"); };
    const navEl = document.querySelector(".kl-nav");
    if (navEl) {
      let b = document.createElement("button");
      b.className = "kl-nav__burger"; b.setAttribute("aria-label", "Menú");
      b.innerHTML = "<span></span><span></span><span></span>";
      (navEl.querySelector(".kl-nav__tools") || navEl).appendChild(b);
      b.addEventListener("click", () => (panel.classList.contains("open") ? closeM() : openM()));
    }
    scrim.addEventListener("click", closeM);
    close.addEventListener("click", closeM);
    panel.querySelectorAll("a").forEach((a) => a.addEventListener("click", closeM));
  })();

  /* --- Buscador Shopify predictivo ----------------------- */
  (function () {
    const ov = document.createElement("div");
    ov.className = "kl-search";
    ov.innerHTML =
      '<div class="kl-search__bar">' +
      '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><line x1="16" y1="16" x2="21" y2="21"/></svg>' +
      '<input type="search" placeholder="Buscar joyas…" aria-label="Buscar">' +
      '<button class="kl-search__close" aria-label="Cerrar">&times;</button></div>' +
      '<div class="kl-search__body"></div>';
    document.body.appendChild(ov);
    const input = ov.querySelector("input");
    const body = ov.querySelector(".kl-search__body");

    function showSuggestions() {
      body.innerHTML = '<p class="kl-search__hint">Sugerencias</p><div class="kl-chips">' +
        ["Arcángeles", "Cruces", "Santos", "Protección", "Balín"].map((c) =>
          "<button>" + c + "</button>").join("") + "</div>";
      body.querySelectorAll(".kl-chips button").forEach((b) =>
        b.addEventListener("click", () => { input.value = b.textContent; doSearch(b.textContent); input.focus(); }));
    }

    async function doSearch(q) {
      q = (q || "").trim();
      if (!q) { showSuggestions(); return; }
      try {
        const res = await fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6");
        const data = await res.json();
        const hits = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!hits.length) {
          body.innerHTML = '<p class="kl-search__hint">Sin resultados para "' + q + '"</p>';
        } else {
          body.innerHTML = '<p class="kl-search__hint">' + hits.length + ' resultado' + (hits.length !== 1 ? "s" : "") + '</p>' +
            '<div class="kl-res">' + hits.map((p) =>
              '<a href="' + p.url + '"><span class="kl-res__info">' +
              '<span class="kl-res__name">' + p.title + '</span>' +
              '<span class="kl-res__mat">' + (p.vendor || "") + '</span></span>' +
              '<span class="kl-res__price">' + (p.price ? "$ " + (parseInt(p.price) / 100).toLocaleString("es-CO") : "") + '</span></a>'
            ).join("") + '</div>';
          body.querySelectorAll("a").forEach((a) => a.addEventListener("click", close));
        }
      } catch (_) {
        showSuggestions();
      }
    }

    function open() { ov.classList.add("show"); showSuggestions(); setTimeout(() => input.focus(), 60); }
    function close() { ov.classList.remove("show"); }
    let t;
    input.addEventListener("input", () => { clearTimeout(t); t = setTimeout(() => doSearch(input.value), 280); });
    ov.querySelector(".kl-search__close").addEventListener("click", close);
    ov.addEventListener("click", (e) => { if (e.target === ov) close(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });
    document.querySelectorAll(".kl-nav__tools").forEach((tools) => {
      const lupa = tools.querySelector("svg.kl-nav__icon");
      if (lupa) { lupa.style.cursor = "pointer"; lupa.addEventListener("click", (e) => { e.preventDefault(); open(); }); }
    });
  })();

  /* --- Newsletter ----------------------------------------- */
  const newsForm = document.querySelector(".kl-news__form");
  if (newsForm) {
    newsForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const note = document.querySelector(".kl-news__note");
      if (note) { note.textContent = "Gracias — revisa tu correo para confirmar."; note.style.color = "var(--green)"; }
      newsForm.reset();
    });
  }

  if (reduce) return;

  /* --- Tilt 3D en tarjetas -------------------------------- */
  document.querySelectorAll("[data-kl-tilt]").forEach((el) => {
    const max = parseFloat(el.dataset.klTilt) || 7;
    let raf = null, tx = 0, ty = 0, cx = 0, cy = 0;
    const glare = el.querySelector(".kl-col-card__glare");
    function frame() {
      cx = lerp(cx, tx, 0.18); cy = lerp(cy, ty, 0.18);
      el.style.transform =
        `rotateX(${(-cy * max).toFixed(2)}deg) rotateY(${(cx * max).toFixed(2)}deg)`;
      if (Math.abs(cx - tx) > 0.001 || Math.abs(cy - ty) > 0.001) raf = requestAnimationFrame(frame);
      else raf = null;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }
    el.addEventListener("pointermove", (ev) => {
      const r = el.getBoundingClientRect();
      tx = ((ev.clientX - r.left) / r.width) * 2 - 1;
      ty = ((ev.clientY - r.top) / r.height) * 2 - 1;
      if (glare) {
        glare.style.setProperty("--mx", `${((ev.clientX - r.left) / r.width) * 100}%`);
        glare.style.setProperty("--my", `${((ev.clientY - r.top) / r.height) * 100}%`);
      }
      kick();
    });
    el.addEventListener("pointerleave", () => { tx = 0; ty = 0; kick(); });
  });

  /* --- Hero: pieza reacciona al mouse + parallax ---------- */
  const piece = document.querySelector(".kl-hero__piece");
  if (piece) {
    let px = 0, py = 0, mx = 0, my = 0, raf = null;
    function frame() {
      px = lerp(px, mx, 0.08); py = lerp(py, my, 0.08);
      const sc = Math.max(0, 1 - window.scrollY / 900);
      piece.style.transform =
        `rotateY(${(px * 12).toFixed(2)}deg) rotateX(${(-py * 9).toFixed(2)}deg) ` +
        `translateY(${(window.scrollY * -0.06).toFixed(1)}px)`;
      piece.style.opacity = (0.35 + 0.65 * sc).toFixed(3);
      if (Math.abs(px - mx) > 0.0005 || Math.abs(py - my) > 0.0005) raf = requestAnimationFrame(frame);
      else raf = null;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }
    window.addEventListener("pointermove", (ev) => {
      mx = (ev.clientX / window.innerWidth) * 2 - 1;
      my = (ev.clientY / window.innerHeight) * 2 - 1;
      kick();
    });
    window.addEventListener("scroll", kick, { passive: true });
  }

  /* --- Parallax imagen Historia --------------------------- */
  const storyImg = document.querySelector(".kl-story__media img");
  const storyWrap = document.querySelector(".kl-story__media");
  if (storyImg && storyWrap) {
    let raf = null;
    function upd() {
      const r = storyWrap.getBoundingClientRect();
      const prog = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
      storyImg.style.transform = `translateY(${(prog * -36).toFixed(1)}px)`;
      raf = null;
    }
    window.addEventListener("scroll", () => { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
})();
